var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8896 0H1.10742C0.495117 0 0 0.483398 0 1.08105V13.916C0 14.5137 0.495117 15 1.10742 15H13.8896C14.502 15 15 14.5137 15 13.9189V1.08105C15 0.483398 14.502 0 13.8896 0ZM4.4502 12.7822H2.22363V5.62207H4.4502V12.7822ZM3.33691 4.64648C2.62207 4.64648 2.04492 4.06934 2.04492 3.35742C2.04492 2.64551 2.62207 2.06836 3.33691 2.06836C4.04883 2.06836 4.62598 2.64551 4.62598 3.35742C4.62598 4.06641 4.04883 4.64648 3.33691 4.64648ZM12.7822 12.7822H10.5586V9.30176C10.5586 8.47266 10.5439 7.40332 9.40137 7.40332C8.24414 7.40332 8.06836 8.30859 8.06836 9.24316V12.7822H5.84766V5.62207H7.98047V6.60059H8.00977C8.30566 6.03809 9.03223 5.44336 10.1133 5.44336C12.3662 5.44336 12.7822 6.92578 12.7822 8.85352V12.7822Z",
    fill: "#333448"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial02);
export default __webpack_public_path__ + "static/media/social-02.2717afc4dcee6b2b6388dd6b3932a299.svg";
export { ForwardRef as ReactComponent };